export const mutableReplace = <T>(arr: T[], predicate: (it: T) => boolean, newItem: T): boolean => {
  const index = arr.findIndex(predicate);
  if (index < 0) {
    return false;
  }
  arr[index] = newItem;
  return true;
};

export const mutableReplaceOrAdd = <T>(arr: T[], predicate: (it: T) => boolean, newItem: T): boolean => {
  if (mutableReplace(arr, predicate, newItem)) {
    return true;
  }
  arr.push(newItem);
  return false;
};
